// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fea026ae","389":"0c08d1b6","553":"986c5c47","977":"ac561f96"}[chunkId] + ".chunk.js";
};